import { vslApi } from '@/api';

export default {
  getCommodityList() {
    return vslApi.get('/v1/commodities');
  },
};
